import agent from './agent';
import {
  ASYNC_START,
  ASYNC_END,
  LOGIN,
  LOGOUT,
  IS_LOADING, APP_LOAD,
} from './constants/actionTypes';

const promiseMiddleware = history => store => next => action => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    store.dispatch({ type: IS_LOADING, isLoading: true });

    const currentView = store.getState().viewChangeCounter;
    const skipTracking = action.skipTracking;

    action.payload.then(
      res => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('RESULT', res);
        action.payload = res;
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);

        store.dispatch({ type: IS_LOADING, isLoading: false });
      },
      error => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('ERROR', error);
        action.error = true;
        action.payload = error.response?.body;

        if (error.response?.status === 401) {
          // window.location.href = '/401';
          history.push('/401');
        } else if (error.response?.status === 404) {
          // window.location.href = '/404';
          history.push('/404');
        }

        if (action.payload && !action.skipTracking) {
          store.dispatch({ type: ASYNC_END, promise: action.payload });
        }
        store.dispatch(action);

        store.dispatch({ type: IS_LOADING, isLoading: false });
      }
    );

    return;
  }

  next(action);
};

const localStorageMiddleware = store => next => action => {
  if (action.type === LOGIN) {
    if (!action.error) {
      // Keep the token in memory only; clear any legacy value left in localStorage.
      window.localStorage.removeItem('jwt');
      agent.setToken(action.payload.user.token);
    }
  } else if (action.type === LOGOUT) {
    window.localStorage.removeItem('jwt');
    agent.setToken(null);
    agent.setUserName(null);
    agent.Auth.logout();
  }

  if (action.type === APP_LOAD) {
    agent.setUserName(action.payload.user?.username);
  }

  next(action);
};

function isPromise(v) {
  return v && typeof v.then === 'function';
}


export { promiseMiddleware, localStorageMiddleware }
